module.exports = __webpack_public_path__ + "img/ricelog_pinicon_060.5e082228.png";